import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { categoriesData } from "../../../../helpers/Arrays";
import DownloadIcon from "@mui/icons-material/Download";
import InfoIcon from "@mui/icons-material/Info";
import { Images } from "../../../../helpers/Images";
// import Images from "../../../../helpers/Images";

const RoboBoomTemplate = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const categories = [
    {
      title: "RoboBoom Discover",
      description:
        "RoboBoom Discover is designed for young explorers to experience the fun of robotics and programming.",
      details: ["Age: 4-6", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1rt8-iTgVT-YGyD0dn4Nvo1ROQ6pP0s_v",
    },
    {
      title: "RoboBoom Construction Smart",
      description:
        "Construction Smart is a event for preschool team members, which encourages them to imagine and innovate boldly.",
      details: ["Age: 4-6", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1sM4mCyu8PLZ2sDVYpwlPMI9Q3YhT-1H0",
    },
    {
      title: "RoboBoom LEGO Sprint",
      description:
        "The robot has passed the pre-competition examination and will compete for the fastest speed along the track with a straight line of more than 9 meters.",
      details: ["Age: 6-10", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1P1HJVP1eyajIBZ0c67YBm44iM0mZxUF8",
    },
    {
      title: "RoboBoom Construction LEGO",
      description:
        "LEGO WEDO is the beginning for LEGO robot beginners to experience the fun of robot programming.",
      details: ["Age: 6-10", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1x-qVwrzmI-DXkHPpQNf54imwQOVTj3OW",
    },
    {
      title: "RoboBoom Challenge",
      description:
        "By using equipment that meets the controller port requirements and programming, remote control and autonomous control of the robot are achieved to complete field object movement tasks.",
      details: ["Age: 6-10", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1oT6-nXHFxDIBEz2xO-2tgwKBtsB6NScX",
    },
    {
      title: "RoboBoom Curling",
      description:
        "A simulated curling competition event. A remote-controlled robot carries and throws curling stones so that they can accurately stop in the high-scoring area.",
      details: ["Age: 6-10", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1y64exSL_iYqsP9nO2Be2XPc18swPPg7S",
    },
    {
      title: "RoboBoom Robot Parade",
      description:
        "RoboBoom Robot Parade is a creative showcase where teams present their innovative robot designs.",
      details: ["Age: 6-10", "Team size: 3-5 people"],
      pdfLink:
        "https://drive.google.com/uc?export=download&id=1acYr3DQKkiEn644mHV7nNKwYnOG0eO5c",
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${Images.roboBoom})`,
          backgroundSize: "cover",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
          color: "white",
          py: 8,
          mb: 6,
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: "700",
              textAlign: "center",
              mb: 2,
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            }}
          >
            RoboBoom Challenge
          </Typography>
          <Typography
            variant="h5"
            sx={{
              textAlign: "center",
              maxWidth: "800px",
              mx: "auto",
              opacity: 0.9,
              textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
            }}
          >
            Explore our exciting robotics competitions designed for young
            innovators
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Grid container spacing={4}>
          {categories.map((category, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: theme.shadows[8],
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "600",
                      mb: 2,
                      color: theme.palette.primary.main,
                    }}
                  >
                    {category.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{ mb: 3, color: "text.secondary" }}
                  >
                    {category.description}
                  </Typography>

                  <Box sx={{ mb: 3 }}>
                    {category.details.map((detail, idx) => (
                      <Typography
                        key={idx}
                        variant="body2"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 1,
                          "&:before": {
                            content: '"•"',
                            mr: 1,
                            color: theme.palette.primary.main,
                          },
                        }}
                      >
                        {detail}
                      </Typography>
                    ))}
                  </Box>

                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    <Button
                      variant="contained"
                      startIcon={<DownloadIcon />}
                      component="a"
                      href={category.pdfLink}
                      download
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        "&:hover": {
                          backgroundColor: theme.palette.primary.dark,
                        },
                      }}
                    >
                      Rules PDF
                    </Button>
                    <Button
                      variant="outlined"
                      //   startIcon={<InfoIcon />}
                      onClick={() => navigate("/firststage")}
                      sx={{
                        borderColor: theme.palette.primary.main,
                        color: theme.palette.primary.main,
                        "&:hover": {
                          borderColor: theme.palette.primary.dark,
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      Register Now
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Box
        sx={{
          width: "100%",
          backgroundColor: "primary.main",
        }}
      >
        <Box
          sx={{
            width: "100%",
            padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
            maxWidth: "1500px",
            margin: "auto",
          }}
        >
          <Typography
            variant={"h2"}
            sx={{
              textAlign: "center",
              fontSize: { xs: "40px" },
              fontWeight: "500",
              color: "secondary.main",
            }}
          >
            Our All Categories
          </Typography>
          <Box
            sx={{
              height: "3px",
              maxWidth: { xs: "100px", md: "150px" },
              width: "100%",
              backgroundColor: "secondary.main",
              margin: "10px auto 0 auto",
            }}
          />
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "50px", justifyContent: "center" }}
          >
            {categoriesData
              ?.filter((category) => category.title !== "RoboBoom")
              ?.map((item) => (
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${item.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      width: "100%",
                      minHeight: { xs: "200px", sm: "250px" },
                      borderRadius: "10px",
                    }}
                  >
                    <Typography
                      variant={"h3"}
                      sx={{
                        textAlign: "center",
                        fontSize: "35px",
                        fontWeight: "500",
                        color: "secondary.main",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        height: "3px",
                        maxWidth: "90px",
                        width: "100%",
                        backgroundColor: "secondary.main",
                        margin: "5px auto 5px auto",
                      }}
                    />
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        sx={{
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "primary.main",
                          width: "fit-content",
                          margin: { xs: "5px 0 20px 0", sm: "10px 0 40px 0" },
                        }}
                        onClick={() => navigate(item.link)}
                      >
                        view
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default RoboBoomTemplate;
